import React from 'react';
import FormatterBar from '../FormatterBar/FormaterBarWithLinkmodel/FormatterBar';
import HTMLtoText from '../HTMLToText/HTMLToText';
import { convertUrlsToLinks } from '../../../utils/common';
import { useAppSelector } from '../../../redux/hooks';
import normalizeEmptyEditorValue from '../../../utils/editor';

interface EditorProps {
  id: string;
  testId?: string;
  isEditing: boolean;
  value: string;
  onChange: (value: string) => void;
  formatterBarPlaceholder: string;
  section: string;
  maxCharacter?: number;
  formatterBarWrapperClassName?: string;
  htmlToPdfContainerClassName?: string;
  isContentEditable?: boolean;
  convertToLink?: boolean;
  normalize?: boolean;
}

const Editor: React.FC<EditorProps> = ({
  id,
  testId,
  isEditing,
  value,
  onChange,
  formatterBarPlaceholder,
  section,
  maxCharacter = 20000,
  formatterBarWrapperClassName,
  htmlToPdfContainerClassName,
  isContentEditable = true,
  convertToLink = false,
  normalize = false,
}) => {
  const currentTheme = useAppSelector((state) => state.theme.currentTheme);

  const handleEditorChange = (rawValue: string) => {
    const next = normalize ? normalizeEmptyEditorValue(rawValue) : rawValue;
    onChange(next);
  };

  if (isEditing) {
    const editor = (
      <FormatterBar
        id={id}
        testId={testId}
        editorData={value}
        handleDataChange={handleEditorChange}
        section={section}
        placeholder={formatterBarPlaceholder}
        isContentEditable={isContentEditable}
        maxCharacter={maxCharacter}
      />
    );

    return formatterBarWrapperClassName ? (
      <div className={formatterBarWrapperClassName}>{editor}</div>
    ) : (
      editor
    );
  }
  const normalizedViewValue = normalize ? normalizeEmptyEditorValue(value) : value;
  const content: string = normalizedViewValue || '-';
  const htmlContent = convertToLink ? convertUrlsToLinks(content, currentTheme) : content;

  return (
    <span className={htmlToPdfContainerClassName}>
      <HTMLtoText htmlContent={htmlContent} />
    </span>
  );
};

export default Editor;
